var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAb6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 48,
    viewBox: "0 0 60 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.91301 12.3594C1.75594 12.3594 0 14.1133 0 16.2724V31.9245C0 34.0836 1.75594 35.8375 3.91301 35.8375C6.0702 35.8375 7.82602 34.0836 7.82602 31.9245V16.2724C7.82613 14.1133 6.0702 12.3594 3.91301 12.3594Z",
    fill: "#00E194"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0868 0.619141C53.9278 0.619141 52.1738 2.37309 52.1738 4.53215V43.6626C52.1738 45.8216 53.9278 47.5756 56.0868 47.5756C58.2459 47.5756 59.9998 45.8216 59.9998 43.6626V4.53227C59.9998 2.37309 58.2459 0.619141 56.0868 0.619141Z",
    fill: "#00E194"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7393 15.6004V32.5953L15.6523 33.7692V37.2318C15.6523 39.8418 17.3337 42.1002 19.8366 42.8491L31.5757 46.3725C33.3102 46.9033 35.2277 46.6036 36.765 45.4591C38.2506 44.3555 39.1049 42.6595 39.1235 40.8106L48.2609 43.1605V5.03516L11.7393 15.6004ZM35.2175 40.7511C35.2175 42.0206 34.0104 43.0055 32.6992 42.6274L20.96 39.104C20.127 38.8517 19.5653 38.099 19.5653 37.2316V34.9428L35.2174 39.6385V40.7511H35.2175Z",
    fill: "#00E194"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAb6);
export default __webpack_public_path__ + "static/media/ab_6.080c67be00359d4c16a6bedb98c3a78b.svg";
export { ForwardRef as ReactComponent };